import {
    GET_CUSTOMERS_LOADING,
    GET_CUSTOMERS_SUCCESS,
    GET_CUSTOMERS_FAILED,
  } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    merchants: null,
  };
  
  export const getCustomerListReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
  ) => {
    switch (action.type) {
      case GET_CUSTOMERS_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
        };
      case GET_CUSTOMERS_SUCCESS:
        return {
          ...state,
          loading: false,
          merchants: action.payload,
          error: null,
        };
      case GET_CUSTOMERS_FAILED:
        return {
          ...state,
          loading: false,
          merchants: null,
          error: action.error,
        };
       
      default:
        return state;
    }
  };
  